exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cellClassAggrid:hover span #iconMap {\n  font-size: 28px !important;\n}\n\n.cellClassAggrid:hover span #iconVideo {\n  font-size: 28px !important;\n}\n\n.cellClassDetailAggrid {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n}\n\n.cellClassDetailAggrid span {\n  height: 31px;\n}\n\n.cellClassDetailAggrid:hover span #infoVOD {\n  font-size: 26px !important;\n}\n", ""]);

// exports
